import { colors } from '@material-ui/core';

export default {
  root: {
    fontWeight: 900,
    marginTop: 0,
    marginBottom: 0
  },
};
